/* @flow */

import * as React from 'react'

const WebshopCenteredContentSettings = ({ values }) => {
  return <div>There are currently no settings for Centered content widget</div>
}

export default WebshopCenteredContentSettings
